import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      borderBottom: `1px solid ${palette.divider}`,
      '&:nth-of-type(even)': {
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
      },
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(25, 118, 210, 0.08)',
        '&:hover': {
          backgroundColor: 'rgba(25, 118, 210, 0.12)',
        }
      }
    },
    head: {
      backgroundColor: palette.background.default,
      borderBottom: `2px solid ${palette.divider}`,
      '&:hover': {
        backgroundColor: palette.background.default,
      }
    }
  }
};
